import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const queryReturn = data => {
    return api.post(`${baseApi}/returnAccountAge/getReturnAccountAgePage`, data);
};

export const QueryReputationsPage = data => {
    return api.post(`${baseApi}/customerCreditArchive/getCustomerCreditArchiveListPage`, data);
};

export const UpdateReputation = data => {
    return api.post(`${baseApi}/customerCreditArchive/saveCustomerCreditArchive`, data);
};

export const SaveReputationFile = data => {
    return api.post(`${baseApi}/fileCenter/uploadImageList`, data);
};

export const CreateReputationCard = data => {
    return api.post(`${baseApi}/customerCreditArchive/addCustomerCreditArchiveExt`, data);
};

export const UpdateReputationCard = data => {
    return api.post(`${baseApi}/customerCreditArchive/updateCustomerCreditArchiveExt`, data);
};

export const DeleteReputationCard = ({ id }) => {
    return api.get(`${baseApi}/customerCreditArchive/deleteCustomerCreditArchiveExt/${id}`);
};

export const QueryReputationFile = data => {
    return api.post(`${baseApi}/customerCreditArchive/getCustomerCreditArchiveExtList`, data);
};

export const QueryFileList = ({ dataId, fileTypeCode }) => {
    return api.get(`${baseApi}/fileCenter/getFileListByDataId/${dataId}/${fileTypeCode}`);
};

export const downloadFile = ({ fileId }) => {
    return api.get(`${baseApi}/fileCenter/downloadFile/${fileId}`, { responseType: 'blob' });
};

export const QueryAgeInfo = ({ customerId }) => {
    return api.get(`${baseApi}/returnAccountAge/getReturnAccountAgeByCustomerId/${customerId}`);
};

export const UpdateAgeData = data => {
    return api.put(`/returnAccountAge/updateReturnAccountAge`, data);
};

// 回款预填
export const QueryReturnMark = data => {
    return api.post(`/returnTargetPrepare/getReturnTargetPreparePage`, data);
};

export const SaveReturnMark = data => {
    return api.post(`/returnTargetPrepare/saveReturnTargetPrepare`, data);
};

export const SubmitReturnMark = data => {
    return api.post(`/returnTargetPrepare/submitReturnTargetPrepare`, data);
};
// 其他资产信息

export const CreateCapital = data => {
    return api.post(`${baseApi}/customerAsset/addCustomerAsset`, data);
};

export const QueryCapital = data => {
    return api.post(`${baseApi}/customerAsset/getCustomerAssetList`, data);
};

export const UpdateCapital = data => {
    return api.post(`${baseApi}/customerAsset/updateCustomerAsset`, data);
};

export const DeleteCapital = ({ assetId }) => {
    return api.get(`${baseApi}/customerAsset/deleteCustomerAsset/${assetId}`);
};

export const UploadCapitalFile = data => {
    return api.post(``, data);
};

// 实际回款

export const QueryActualReturn = data => {
    return api.post(`${baseApi}/returnActual/getReturnActualPage`, data);
};

export const UpdateActualReturn = data => {
    return api.post(`${baseApi}/returnActual/updateReturnActual`, data);
};

export const SaveActualReturn = data => {
    return api.post(`/returnActual/saveReturnActual`, data);
};

export const QueryActualMonth = data => {
    return api.post(`/returnActual/getReturnActual4MonthPage`, data);
};

export const UpdateActualMonth = data => {
    return api.post(``, data);
};

export const SaveDocument = ({ year }) => {
    return api.get(`/returnAccountAgeArchive/saveReturnAccountAgeArchive/${year}`);
};

export const QueryCustomerMontList = data => {
    return api.post(`/returnActual/getReturnActualListByCustomer`, data);
};

// 回款计划
export const QueryReturnPlan = data => {
    return api.post(`${baseApi}/returnTarget/getReturnTargetPage`, data);
};

export const UpdateReturnPlan = data => {
    return api.post(`${baseApi}/returnTarget/updateReturnTarget`, data);
};

export const QueryConfirmList = data => {
    return api.post(`/returnTargetPrepare/getReturnTargetPrepare4ConfirmPage`, data);
};

export const ConfirmReturnMark = data => {
    return api.post(`/returnTargetPrepare/submitReturnTargetPrepare`, data);
};
// 调整

export const adjustReturn = data => {
    return api.post(`${baseApi}/returnActualAdjust/saveReturnActualAdjust`, data);
};

export const QueryAdjustReturn = data => {
    return api.post(`${baseApi}/returnActualAdjust/getReturnActualAdjustInfo`, data);
};

export const QueryAdjustList = data => {
    return api.post(`${baseApi}/returnActualAdjust/getReturnActualAdjustPage`, data);
};

export const QueryAgingRiskList = ({ customerId }) => {
    return api.get(`/recordIssue/getUnsolvedReturnedIssueByCustomerId/${customerId}`);
};

export const QueryDocumentList = data => {
    return api.post(`/returnAccountAgeArchive/getReturnAccountAgeArchivePage`, data);
};

// 回款数据接口

export const QueryReturnAreaData = data => {
    return api.post(`/returnActual/getReturnActualOverallAnalysis4Area`, data);
};

export const QueryReturnUserData = data => {
    return api.post(`/returnActual/getReturnActualOverallAnalysis4UserPage`, data);
};

export const QueryReturnCustomerData = data => {
    return api.post(`/returnActual/getReturnActualOverallAnalysis4CustomerPage`, data);
};

// 查询客户的收入

export const QueryCustomerIncomeInfo = ({ customerId, year }) => {
    return api.get(`/incomeActual/getIncomeActualByCustomerAndYear/${customerId}/${year}`);
};

// 实际回款分析

export const QueryActualAreaData = data => {
    return api.post(``, data);
};

export const QueryActualUserData = data => {
    return api.post(``, data);
};

export const QueryActualCustomerData = data => {
    return api.post(``, data);
};

export const QueryCreditData = data => {
    return api.post(`/returnActual/getCustomerCreditArchiveExtYearMonthComparisonAnalysis4Area`, data);
};

export const QueryDiffConditions = data => {
    return api.get(`/returnDifficult/getReturnDifficultNotSolveByCustomerId/${data.customerId}`);
};

export const AddDiffConditions = data => {
    return api.post(`/returnDifficult/addReturnDifficult`, data);
};

export const UpdateDiffConditions = data => {
    return api.post(`/returnDifficult/updateReturnDifficult`, data);
};

// 回款计划的编辑更新接口变动
export const GetReturnTarget = data => {
    return api.post(`/returnTarget/getSingleReturnTargetByConditions`, data);
};
// 月份数据
export const SaveReturnTargetMonth = data => {
    return api.post(`/returnTarget/saveReturnTarget`, data);
};
// 其他修改
export const UpdateReturnTargetOther = data => {
    return api.post(`/returnTargetExt/saveReturnTargetExt`, data);
};

export const GetReturnTargetOther = data => {
    return api.post(`/returnTargetExt/getSingleReturnTargetExtByConditions`, data);
};

export const QueryReturnKeypoint = data => {
    return api.post(`/actionKeypoint/getActionKeypointList4CustomerReturnIng`, data);
};

// 回款困难

export const QueryReturnDiffcultReason = data => {
    return api.post(`/returnDifficultReason/getReturnDifficultReasonListPage`, data);
};

export const SaveReturnDiffcultReason = data => {
    return api.post(`/returnDifficultReason/addReturnDifficultReason`, data);
};

export const UpdateReturnDiffcultReason = data => {
    return api.post(`/returnDifficultReason/updateReturnDifficultReason`, data);
};

export const GetReturnDiffcultReason = ({ reasonId }) => {
    return api.get(`/returnDifficultReason/getReturnDifficultReasonById/${reasonId}`);
};

export const QueryReturnDiffcultPage = data => {
    return api.post(`/returnDifficult/getReturnDifficultListPage`, data);
};

export const UpdateReturnDiffcult = data => {
    return api.post(`/returnDifficult/updateReturnDifficult`, data);
};

export const SaveReturnDiffcult = data => {
    return api.post(`/returnDifficult/addReturnDifficult`, data);
};

export const DealReturnDiffcult = ({ difficultId }) => {
    return api.get(`/returnDifficult/updateReturnDifficult2SolveState/${difficultId}`);
};

// 困难类型
export const QueryDifficultTypeData = data => {
    return api.post(`/returnDifficult/getReturnDifficultAnalysisByDifficultReasonTypeCode`, data);
};

export const QueryDifficultPartyData = data => {
    return api.post(`/returnDifficult/getReturnDifficultAnalysisByResponsiblePartyCode`, data);
};

export const QueryDifficultPropData = data => {
    return api.post(`/returnDifficult/getReturnDifficultAnalysisByCustomerPropCode`, data);
};

export const QueryDifficultLevelData = data => {
    return api.post(`/returnDifficult/getReturnDifficultAnalysisByCustomerLevelCode`, data);
};

export const QueryReturnAnly = data => {
    return api.post(`/returnActual/getGapFillAnalysis4Customer`, data);
};

export const QueryReturnAreaAbmut = data => {
    return api.post(`/returnActual/getGapFillAnalysis4Area`, data);
};

export const QueryReturnUserAbmut = data => {
    return api.post(`/returnActual/getGapFillAnalysis4UserPage`, data);
};

export const QueryReturnCustomerAbmut = data => {
    return api.post(`/returnActual/getGapFillAnalysis4Customer`, data);
};

export const QueryFocusCustomerPage = data => {
    return api.post(`/returnMatterCustomer/getReturnMatterCustomerListPage`, data);
};

export const MarkFocusCustomer = data => {
    return api.post(`/returnMatterCustomer/saveReturnMatterCustomerBatch`, data);
};

export const DeleteFocusCustomer = data => {
    return api.post(`/returnMatterCustomer/deleteReturnMatterCustomerBatch`, data);
};

export const UpdateFocusCustomer = data => {
    return api.post(`/returnMatterCustomer/updateReturnMatterCustomer`, data);
};

// 清单

export const QueryListPage = data => {
    return api.post(`/returnSchedule/getReturnScheduleListByCustomerIdPage`, data);
};

export const QueryShowPage = data => {
    return api.post(`/returnSchedule/getReturnScheduleListPage`, data);
};

export const UpdateDataList = data => {
    return api.post(`/returnSchedule/updateReturnSchedule`, data);
};

export const AddDataList = data => {
    return api.post(`/returnSchedule/addReturnSchedule`, data);
};

export const AddDataListBatch = data => {
    return api.post(`/returnSchedule/addReturnScheduleBatch`, data);
};

export const QueryDatalistFinish = data => {
    return api.post(`/returnSchedule/getReturnScheduleFinishAnalysis4CustomerPage`, data);
};

export const UpdateCancelFollowUp = data => {
    return api.post(`/returnMatterCustomer/updateReturnMatterCustomer4CancelFollowUp`, data);
};

export const DeleteMainDatalist = ({ customerId }) => {
    return api.get(`/returnSchedule/deleteReturnScheduleByCustomerId/${customerId}`);
};

export const InsserRemarkFinish = data => {
    return api.post(`/returnSchedule/updateReturnScheduleRemark`, data);
};

export const QueryForecastRate = data => {
    return api.post(`/returnTarget/getForecastReturnRate4CustomerPage`, data);
};

// 风险分析
export const QueryReturnRate = data => {
    return api.post(`/returnActual/getReturnRate4Area`, data);
};

export const QueryReturnUserRate = data => {
    return api.post(`/returnActual/getReturnRate4UserPage`, data);
};

export const QueryReturnCustomerRate = data => {
    return api.post(`/returnActual/getReturnRate4CustomerPage`, data);
};

export const QueryReturnFinishAreaRate = data => {
    return api.post(`/returnActual/getReturnTargetFinishRate4Area`, data);
};

export const QueryReturnFinishUserRate = data => {
    return api.post(`/returnActual/getReturnTargetFinishRate4UserPage`, data);
};

export const QueryReturnFinishCustomerRate = data => {
    return api.post(`/returnActual/getReturnTargetFinishRate4CustomerPage`, data);
};

// 账期
// 数字账期

export const QueryNumAccountPeriod = data => {
    return api.post(`/returnAccountPeriod/getReturnAccountPeriod4TwelvePage`, data);
};

export const SaveAccountPeriod = data => {
    return api.post(`/returnAccountPeriod/saveReturnAccountPeriod`, data);
};

export const UpdateAccountPeriod = data => {
    return api.post(`/returnAccountPeriod/updateReturnAccountPeriod4AgeByRule`, data);
};

// 挂账账期
export const QueryChargeAccountPeriod = data => {
    return api.post(``, data);
};

// 挂账占比

export const QueryChargePrecent = data => {
    return api.post(``, data);
};

// 历史挂账
export const QueryHisAccount = data => {
    return api.post(`/returnAccountTotal/getReturnAccountTotal4TwelveMonthPage`, data);
};

export const SaveHisAccount = data => {
    return api.post(`/returnAccountTotal/saveReturnAccountByAge`, data);
};

export const InsertHisAccount = data => {
    return api.post(`/returnAccountTotal/saveReturnAccountTotal`, data);
};

// 回款案件
export const QueryReturnCase = data => {
    return api.post(`/returnCase/getReturnCasePage`, data);
};

export const SaveReturnCase = data => {
    return api.post(`/returnCase/addReturnCase`, data);
};

export const UpdateReturnCase = data => {
    return api.post(`/returnCase/updateReturnCase`, data);
};

export const DeleteReturnCase = ({ caseId }) => {
    return api.delete(`/returnCase/deleteReturnCase/${caseId}`);
};

export const QueryCaseInfo = ({ caseId }) => {
    return api.get(`/returnCase/selectByCaseId/${caseId}`);
};

// 账期情况
export const QueryAreaPeriod = data => {
    return api.post(`/returnAccountPeriodArea/getReturnAcoountPeriodArea12Month`, data);
};

export const QueryCustomerPeriod = data => {
    return api.post(``, data);
};

export const MarkAreaPeriod = data => {
    return api.post(`/returnAccountPeriodArea/updateReturnAccountPeriodAreaByHistory`, data);
};

export const QueryMarkRule = data => {
    return api.post(`/returnAccountPeriodArea/getReturnAccountPeriodAreaCalculationBasis`, data);
};

export const QueryCustomerRule = data => {
    return api.post(`/returnAccountPeriod/getReturnAccountPeriodCalculationBasis`, data);
};

// 诉讼回款的明细
export const QueryCaseReturnDetail = data => {
    return api.post(``, data);
};

// 客户属性占比
export const QueryClientItem = data => {
    return api.post('/returnAccountTotal/getReturnAccountTotalByCustomerProperty', data);
};
export const QueryCustomerProperty = data => {
    return api.post(`/returnAccountTotal/getReturnAccountTotalByCustomerProperty4CustomerList`, data);
};

export const QuerySectionData = data => {
    return api.post(`/returnAccountTotal/getReturnAccountTotalByTotalSection`, data);
};
//
export const QueryPrecentMain = data => {
    return api.post(``, data);
};

export const UpdateFinishList = data => {
    return api.post(`/returnSchedule/saveReturnSchedule`, data);
};
